export default __webpack_public_path__ + "static/docker-a96c34c0a676c881dac6f2dc73da79ea.svg";